module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-profile-page"
  }, [_c('div', {
    staticClass: "container edit-user-template"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [(_vm.canEditDetails) ? [_vm._v("\n        Edit account settings\n      ")] : [_vm._v("\n        Account settings\n      ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyDetails'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "25",
      "height": "19.667",
      "viewBox": "0 0 25 19.667"
    }
  }, [_c('path', {
    attrs: {
      "id": "organisation-details",
      "d": "M-12186.666-8295.333h-18.667A2.669,2.669,0,0,1-12208-8298v-13.333a2.669,2.669,0,0,1,2.666-2.667h18.667a2.67,2.67,0,0,1,2.667,2.667V-8298A2.67,2.67,0,0,1-12186.666-8295.333Zm-13.6-6.667a1,1,0,0,1,1,1v1.666h2.333a.667.667,0,0,0,.667-.666v-9a1,1,0,0,0-1-1h-6a1,1,0,0,0-1,1v9a.667.667,0,0,0,.667.666h2.333V-8301A1,1,0,0,1-12200.268-8302Zm7.6-1.334a.668.668,0,0,0-.666.667.667.667,0,0,0,.666.667h5.333a.667.667,0,0,0,.667-.667.668.668,0,0,0-.667-.667Zm0-2.666a.667.667,0,0,0-.666.667.667.667,0,0,0,.666.666h5.333a.667.667,0,0,0,.667-.666.667.667,0,0,0-.667-.667Zm0-2.667a.667.667,0,0,0-.666.667.667.667,0,0,0,.666.667h5.333a.667.667,0,0,0,.667-.667.667.667,0,0,0-.667-.667Zm-5.935,5.333h-.667a.333.333,0,0,1-.333-.333v-.667a.334.334,0,0,1,.333-.333h.667a.33.33,0,0,1,.333.333v.667A.334.334,0,0,1-12198.6-8303.334Zm-2.667,0h-.667a.334.334,0,0,1-.333-.333v-.667a.335.335,0,0,1,.333-.333h.667a.33.33,0,0,1,.333.333v.667A.333.333,0,0,1-12201.268-8303.334Zm2.667-2h-.667a.334.334,0,0,1-.333-.334v-.666a.334.334,0,0,1,.333-.334h.667a.331.331,0,0,1,.333.334v.666A.335.335,0,0,1-12198.6-8305.333Zm-2.667,0h-.667a.335.335,0,0,1-.333-.334v-.666a.335.335,0,0,1,.333-.334h.667a.331.331,0,0,1,.333.334v.666A.334.334,0,0,1-12201.268-8305.333Zm2.667-2.021h-.667a.328.328,0,0,1-.333-.313v-.666a.334.334,0,0,1,.333-.334h.667a.335.335,0,0,1,.333.334v.666A.316.316,0,0,1-12198.6-8307.354Zm-2.667,0h-.667a.329.329,0,0,1-.333-.313v-.666a.335.335,0,0,1,.333-.334h.667a.334.334,0,0,1,.333.334v.666A.316.316,0,0,1-12201.268-8307.354Z",
      "transform": "translate(12208.499 8314.5)",
      "fill": "currentColor",
      "stroke": "rgba(0,0,0,0)",
      "stroke-width": "1"
    }
  })])]), _vm._v(" "), (_vm.canEditDetails === false) ? [_vm._v("Organisation details")] : [_vm._v("Edit organisation details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyOwner'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyOwner')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 10 20"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 10 20",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_2_",
      "cx": "5",
      "cy": "3",
      "r": "3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_3_",
      "d": "M5,6c-2.757,0-5,2.243-5,5v3c0,0.552,0.448,1,1,1h1v4c0,0.552,0.448,1,1,1h4\n                      c0.552,0,1-0.448,1-1v-4h1c0.552,0,1-0.448,1-1v-3C10,8.243,7.757,6,5,6z"
    }
  })])])]), _vm._v(" "), (_vm.canEditOwner === false) ? [_vm._v("Account owner details")] : [_vm._v("Edit account owner details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'tasksSettings'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('tasksSettings')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "26.411",
      "height": "19.751",
      "viewBox": "0 0 26.411 19.751"
    }
  }, [_c('path', {
    attrs: {
      "id": "task_settings",
      "data-name": "task settings",
      "d": "M-12206.906-8295.249a1.171,1.171,0,0,1-1.094-1.158,1.109,1.109,0,0,1,1.094-1.094h13.53a1.127,1.127,0,0,1,1.127,1.124,1.128,1.128,0,0,1-1.127,1.128Zm14.746-5.626h0Zm-12.5,0a1.125,1.125,0,0,1-1.094-1.127,1.126,1.126,0,0,1,1.094-1.125h10.258a9.02,9.02,0,0,0,2.239,2.252Zm15.156-1.253a.378.378,0,0,1-.294-.373v-1.263a4.446,4.446,0,0,1-1.422-.818l-1.094.632a.378.378,0,0,1-.2.052c-.512,0-1.5-1.991-1.5-2.319a.386.386,0,0,1,.192-.331l1.091-.631a4.539,4.539,0,0,1-.076-.821,4.588,4.588,0,0,1,.076-.821l-1.091-.631a.382.382,0,0,1-.192-.328c0-.4,1.035-2.322,1.5-2.322a.408.408,0,0,1,.2.052l1.094.632a4.558,4.558,0,0,1,1.422-.818v-1.263a.379.379,0,0,1,.294-.37,5.771,5.771,0,0,1,1.207-.129,5.75,5.75,0,0,1,1.2.129.376.376,0,0,1,.295.37v1.263a4.542,4.542,0,0,1,1.421.818l1.1-.632a.389.389,0,0,1,.192-.052c.512,0,1.5,1.991,1.5,2.322a.39.39,0,0,1-.192.331l-1.091.631a4.692,4.692,0,0,1,.076.818,4.725,4.725,0,0,1-.076.821l1.091.631a.386.386,0,0,1,.192.331c0,.4-1.035,2.319-1.5,2.319a.36.36,0,0,1-.192-.052l-1.1-.632a4.494,4.494,0,0,1-1.421.821v1.263a.4.4,0,0,1-.316.37,5.906,5.906,0,0,1-1.2.129A5.932,5.932,0,0,1-12189.5-8302.128Zm-.668-5.873a1.875,1.875,0,0,0,1.875,1.875,1.878,1.878,0,0,0,1.876-1.875,1.879,1.879,0,0,0-1.876-1.875A1.877,1.877,0,0,0-12190.169-8308Zm-5.661,1.5h-11.076a1.17,1.17,0,0,1-1.094-1.158,1.109,1.109,0,0,1,1.094-1.094h10.92c-.007.178-.013.337-.013.5a9.039,9.039,0,0,0,.172,1.752Z",
      "transform": "translate(12208.5 8314.5)",
      "fill": "currentColor",
      "stroke": "rgba(0,0,0,0)",
      "stroke-width": "1"
    }
  })])]), _vm._v(" "), (_vm.canEditTasksSettings === false) ? [_vm._v("Task settings")] : [_vm._v("Edit task settings")]], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "companyDetails",
    staticClass: "content-section profile-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyDetails' || _vm.canEditDetails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("Organisation details")] : [_vm._v("Edit organisation details")]], 2), _vm._v(" "), (_vm.canEditDetails === false && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n              Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-name"
    }
  }, [_vm._v("Organisation name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.name),
      expression: "company.details.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.canEditDetails && _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails,
      'not-empty': _vm.company.details.name !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-name",
      "name": "Company name"
    },
    domProps: {
      "value": (_vm.company.details.name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.canEditDetails && this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-size"
    }
  }, [_vm._v("Organisation size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.companySize),
      expression: "company.details.companySize"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.canEditDetails && _vm.errors.has('Organisation size'),
      'is-blocked': _vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": true,
      "data-lpignore": "true",
      "id": "company-size",
      "name": "Organisation size"
    },
    domProps: {
      "value": (_vm.company.details.companySize)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "companySize", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.canEditDetails && this.errors.has('Organisation size')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation size')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "industry-sector"
    }
  }, [_vm._v("Industry sector")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.canEditDetails && _vm.errors.has('Industry sector'),
      'is-locked': !_vm.canEditDetails,
      'not-empty': _vm.company.details.industrySector !== null
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": true,
      "clearable": false,
      "options": _vm.userIndustrySectors,
      "data-lpignore": "true",
      "name": "Industry sector",
      "id": "industry-sector"
    },
    model: {
      value: (_vm.company.details.industrySector),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "industrySector", $$v)
      },
      expression: "company.details.industrySector"
    }
  }), _vm._v(" "), (_vm.canEditDetails && this.errors.has('Industry sector')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry sector')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.company.details.marketplace) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "marketplace"
    }
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.marketplace),
      expression: "company.details.marketplace"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.canEditDetails && _vm.errors.has('Marketplace'),
      'is-blocked': _vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": true,
      "data-lpignore": "true",
      "id": "marketplace",
      "name": "Marketplace"
    },
    domProps: {
      "value": (_vm.company.details.marketplace)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "marketplace", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.canEditDetails && this.errors.has('Marketplace')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Marketplace')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyDetails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "companyOwner",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyOwner' || _vm.canEditOwner
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditOwner === false) ? [_vm._v("Account owner details")] : [_vm._v("Edit account owner details")]], 2), _vm._v(" "), (_vm.canEditOwner === false && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditOwner()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n              Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.firstName),
      expression: "company.ownerData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditOwner,
      'not-empty': _vm.company.ownerData.firstName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.company.ownerData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.phoneNumber),
      expression: "company.ownerData.phoneNumber"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditOwner,
      'not-empty': _vm.company.ownerData.phoneNumber !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.company.ownerData.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.lastName),
      expression: "company.ownerData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditOwner,
      'not-empty': _vm.company.ownerData.lastName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.company.ownerData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.email),
      expression: "company.ownerData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditOwner,
      'not-empty': _vm.company.ownerData.email !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.company.ownerData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditOwner && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditOwner()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyOwner()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "tasksSettings",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'tasksSettings' || _vm.canEditTasksSettings
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditTasksSettings === false) ? [_vm._v("Task settings")] : [_vm._v("Edit tasks settings")]], 2), _vm._v(" "), (_vm.canEditTasksSettings === false && _vm.getUserRole === 'ca') ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTasksSettings()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-contraption"
    }
  }, [_vm._v("Company contraption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.tasksSettings.contraption),
      expression: "company.tasksSettings.contraption"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company contraption'),
      'is-locked': !_vm.canEditTasksSettings,
      'not-empty': _vm.company.tasksSettings.contraption !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTasksSettings === false,
      "data-lpignore": "true",
      "id": "company-contraption",
      "name": "Company contraption"
    },
    domProps: {
      "value": (_vm.company.tasksSettings.contraption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.tasksSettings, "contraption", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-default-assignee"
    }
  }, [_vm._v("Default assignee")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Default assignee'),
      'is-locked': !_vm.canEditTasksSettings,
      'not-empty': _vm.company.tasksSettings.defaultAssignee !== null
    }],
    attrs: {
      "disabled": _vm.canEditTasksSettings === false,
      "searchable": true,
      "options": _vm.defaultAssigneeForSelect,
      "data-vv-name": "Default assignee",
      "data-lpignore": "true",
      "name": "Default assignee",
      "id": "company-default-assignee"
    },
    model: {
      value: (_vm.company.tasksSettings.defaultAssignee),
      callback: function($$v) {
        _vm.$set(_vm.company.tasksSettings, "defaultAssignee", $$v)
      },
      expression: "company.tasksSettings.defaultAssignee"
    }
  }), _vm._v(" "), (this.errors.has('Default assignee')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Default assignee')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditTasksSettings) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditTasksSettings()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyTasksSettings()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e523360","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AccountSettings.vue
// module id = 963
// module chunks = 0